export type SchoolStaffRole = {
  id: string;
  role: string;
  amount: number;
};

export type SchoolProfile = {
  schoolName: string;
  foundation: string;
  region: string;
  staffRoles: SchoolStaffRole[];
  educationalType: string;
  organisationType: string;
  schoolType: string;
  specification: string;
  coursePlan: string | null;
  trainingPlan: string | null;
  learningPaths: string | null;
};

const storageKey = "peer-start-school-profile";

export const defaultSchoolProfile: SchoolProfile = {
  schoolName: "Basisschool De Linde",
  foundation: "Stichting De Linde Onderwijs",
  region: "Utrecht",
  staffRoles: [
    { id: "teachers", role: "Leraar", amount: 12 },
    { id: "support", role: "Onderwijsondersteuner", amount: 3 },
    { id: "quality", role: "Intern begeleider", amount: 1 },
    { id: "manager", role: "Schoolleider", amount: 1 },
    { id: "mentor", role: "Coach", amount: 1 },
  ],
  educationalType: "Regulier onderwijs",
  organisationType: "Reguliere school",
  schoolType: "Basisonderwijs",
  specification: "Montessori",
  coursePlan: "Jaarplan De Linde 2026.pdf",
  trainingPlan: "Scholingsplan 2026.xlsx",
  learningPaths: "Leerlijnen De Linde 2026.pdf",
};

export function loadSchoolProfile(): SchoolProfile {
  if (typeof localStorage === "undefined") return defaultSchoolProfile;
  const stored = localStorage.getItem(storageKey);
  if (!stored) return defaultSchoolProfile;
  try {
    const profile = { ...defaultSchoolProfile, ...(JSON.parse(stored) as Partial<SchoolProfile>) };
    return {
      ...profile,
      staffRoles: profile.staffRoles.map((entry) => ({
        ...entry,
        role: entry.role === "Mentor" ? "Coach" : entry.role,
      })),
    };
  } catch {
    return defaultSchoolProfile;
  }
}

export function saveSchoolProfile(profile: SchoolProfile): void {
  localStorage.setItem(storageKey, JSON.stringify(profile));
}
